/**
 * Returns document body element
 * @return {number} - The document body element
 */
export const getBody = (): HTMLElement | null => {
	return document.body;
};
